import {
    LOAD_STOW_ASSOCIATES_CALL_BEGIN,
    LOAD_STOW_ASSOCIATES_CALL_SUCCESS,
    LOAD_STOW_ASSOCIATES_CALL_FAILURE,
} from "../actions/AssociateActions";

const initialState = {
    loading: true,
    associatesList: []
};

/**
 * Reducer function for Associate View that changes state
 * based on the action triggered.
 */
export default function associateReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_STOW_ASSOCIATES_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_STOW_ASSOCIATES_CALL_SUCCESS:
            return {
                ...state,
                loading: false,
                associatesList: action.associatesList
            };
        case LOAD_STOW_ASSOCIATES_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/AssociateReducer.js